import { LocationItem } from './locations.model';

export class LocationInfoModel implements LocationItem {
  ApproxValueCd: string;
  CountyNm: string;
  CtrAddress: string;
  CtrCity: string;
  CtrNm: string;
  CtrPhoneNum: string;
  CtrStateAbbr: string;
  CtrZipCd: string;
  Distance: number;
  DwRecordCreateDt: string;
  EndDt: string;
  Id: number;
  Latitude: number;
  LocNameDesc: string;
  Longitude: number;
  ParentCtrCity: string;
  ParentCtrNm: string;
  Shape: any;
  SiteUrl: string;
  StateNm: string;
  UrlTxt: string;
  FilteredResultsReturned: boolean;

  public getExcelFormat(): any {
    const website = this.getWebsiteLink();
    return {
      'Health Center Name': this.CtrNm,
      'Operated By': this.ParentCtrNm != null && this.ParentCtrNm.length > 0 ? this.ParentCtrNm : '',
      'Street Address': this.CtrAddress,
      City: this.CtrCity,
      State: this.CtrStateAbbr,
      'ZIP Code': this.CtrZipCd,
      'Telephone Number': this.CtrPhoneNum,
      Website: website
    };
  }

  /* Take from the legacy locator.  format the health center's website address into a working link.  If the link is
    determined to be invalid, return empty string.*/
  public getWebsiteLink(): string {
    if (typeof this.UrlTxt == 'undefined' || this.UrlTxt == null || this.UrlTxt == '') {
      return '';
    }
    let urlLower = this.UrlTxt.toLowerCase();
    if (
      urlLower == 'n/a' ||
      urlLower == 'na' ||
      urlLower == 'none' ||
      this.UrlTxt.indexOf(' ') != -1 ||
      this.UrlTxt.indexOf('@') != -1
    ) {
      return '';
    }
    if (urlLower.substr(0, 3).toLowerCase() == 'ww.') {
      urlLower = 'w' + urlLower;
    }
    if (urlLower.substr(0, 8) == 'https://') {
      urlLower = urlLower.replace('https://', 'http://');
    }
    if (urlLower.substr(0, 7) != 'http://') {
      urlLower = 'http://' + urlLower;
    }
    return urlLower;
  }
}
